import { Injectable } from '@angular/core';
import { BaseLocalStorageService } from '@shared/data-access';
import { ListOfficerFacade } from '@shared/feature/list-officer';
import { Router } from '@angular/router';
import { AppRoutes } from '@shared/utils/navigation';

@Injectable({
  providedIn: 'root',
})
export class CacheUsersHelperService {
  constructor(private localStorage: BaseLocalStorageService, private router: Router, private listOfficerFacade: ListOfficerFacade) {}

  public handleListPaginationOfficersOnOfficerDeletion(query: string, count: number, identifier: string, autoClearFilters: boolean): void {
    if (autoClearFilters) {
      this.modifySkipInQueryAndListPaginationOfficers(query, 1);

      return;
    }

    const storedPage = this.localStorage.getItem(`${identifier} page`) as string;
    const parsedPage = parseInt(storedPage);

    if (parsedPage && parsedPage !== 1) {
      const totalPages = Math.ceil(count / 10);
      const currentPage = parsedPage;

      if (currentPage > totalPages) {
        const newPage = currentPage - 1;
        this.localStorage.setItem(`${identifier} page`, newPage);
        this.modifySkipInQueryAndListPaginationOfficers(query, newPage);
      } else {
        this.modifySkipInQueryAndListPaginationOfficers(query, currentPage);
      }
    } else {
      this.modifySkipInQueryAndListPaginationOfficers(query, 1);
    }
  }

  private modifySkipInQueryAndListPaginationOfficers(query: string, page: number): void {
    const skipRegex = /\$skip=(\d+)/;
    const skipValue = (page - 1) * 10;
    let modifiedQuery = query;

    const match = query.match(skipRegex);

    if (match) {
      modifiedQuery = query.replace(skipRegex, `$skip=${skipValue}`);
      this.router.navigate([`/${AppRoutes.Users}`]);
      this.listOfficerFacade.listPaginationOfficers(modifiedQuery);
    } else {
      this.router.navigate([`/${AppRoutes.Users}`]);
      this.listOfficerFacade.listPaginationOfficers(query);
    }
  }
}
